"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegulatoryAssessmentGroupStatus = void 0;
exports.instanceOfRegulatoryAssessmentGroupStatus = instanceOfRegulatoryAssessmentGroupStatus;
exports.RegulatoryAssessmentGroupStatusFromJSON = RegulatoryAssessmentGroupStatusFromJSON;
exports.RegulatoryAssessmentGroupStatusFromJSONTyped = RegulatoryAssessmentGroupStatusFromJSONTyped;
exports.RegulatoryAssessmentGroupStatusToJSON = RegulatoryAssessmentGroupStatusToJSON;
exports.RegulatoryAssessmentGroupStatusToJSONTyped = RegulatoryAssessmentGroupStatusToJSONTyped;
/**
 *
 * @export
 */
exports.RegulatoryAssessmentGroupStatus = {
    Imcomplete: 'IMCOMPLETE',
    Complete: 'COMPLETE',
    Open: 'OPEN',
    Expired: 'EXPIRED'
};
function instanceOfRegulatoryAssessmentGroupStatus(value) {
    for (const key in exports.RegulatoryAssessmentGroupStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.RegulatoryAssessmentGroupStatus, key)) {
            if (exports.RegulatoryAssessmentGroupStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function RegulatoryAssessmentGroupStatusFromJSON(json) {
    return RegulatoryAssessmentGroupStatusFromJSONTyped(json, false);
}
function RegulatoryAssessmentGroupStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RegulatoryAssessmentGroupStatusToJSON(value) {
    return value;
}
function RegulatoryAssessmentGroupStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=RegulatoryAssessmentGroupStatus.js.map